import { CommentTextMultipleOutlineIcon } from './CommentTextMultipleOutlineIcon';

/**
 * author: Michael Richins
 * id B7CBD1E2-9677-4D9B-B7BD-CA5493920BE6
 * name comment-text-multiple-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-text-multiple-outline.svg
 * tags
 */
export const CommentsTextOutlineIcon = CommentTextMultipleOutlineIcon;
export default CommentsTextOutlineIcon